<template>
    <div v-if="!person">
        <v-alert v-if="memberLevel === 'GUEST'" border="start" border-color="info">
            <span :class="{'mb-4 d-block': $breakpoint.smAndDown}" class="text-subtitle-1 me-2">
                {{ $t('notes.logged_unregistered') }}
            </span>
            <v-btn variant="flat" :disabled="disabled" color="primary" class="me-2" @click="memberLevel = 'AUTH'">
                {{ $t('sign_in') }}
            </v-btn>
            <v-btn
                :disabled="disabled"
                color="primary"
                variant="text"
                class="text-capitalize"
                @click="memberLevel = 'REGISTERED'"
            >
                {{ $t('register_new_account') }}?
            </v-btn>
        </v-alert>
        <v-card v-else variant="outlined" class="mb-5" :disabled="disabled">
            <v-card-title class="text-h6 font-weight-light">
                {{ memberLevel === 'REGISTERED' ? $t('register') : $t('sign_in') }} {{ $t('or') }}&nbsp;
                <a href="#" class="font-weight-medium text-decoration-none" @click.prevent="memberLevel = 'GUEST'">
                    {{ $t('continue_as_guest') }}
                </a>
            </v-card-title>
            <v-card-text>
                <registration-form v-if="memberLevel === 'REGISTERED'" hide-btn />
                <template v-if="memberLevel === 'AUTH'">
                    <authorization-form v-if="!forgotPassword" @switch-forgot-password="forgotPassword = true" />
                    <template v-if="forgotPassword">
                        <div class="text-h6 mt-4">{{ $t('forgot_your_password') }}</div>
                        <forgot-password-form
                            @switch-login="forgotPassword = false"
                            @forgot-password-success="forgotPassword = false"
                        />
                    </template>
                </template>
            </v-card-text>
        </v-card>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import RegistrationForm from '~src/components/account/forms/registrationForm.src'
    // TODO [P3] Need replace to NewB2cAuthorizationForm - click - show login modal
    import AuthorizationForm from '@/components/account/forms/AuthorizationForm.vue'

    import ForgotPasswordForm from '@/components/account/forms/ForgotPasswordForm.vue'

    @Component({
        components: {ForgotPasswordForm, AuthorizationForm, RegistrationForm},
    })
    export class AccountBookingInfo extends Vue {
        @Prop({default: false, type: Boolean}) disabled

        forgotPassword = false

        get person() {
            return authStore.person
        }

        get memberLevel() {
            return authStore.registeredPerson.memberLevel
        }

        set memberLevel(memberLevel) {
            authStore.SET_REGISTERED_PERSON_PROP({prop: 'memberLevel', val: memberLevel})
        }
    }

    export default AccountBookingInfo
</script>

<style lang="scss" scoped>
    .v-alert {
        background-color: rgba(0, 0, 0, 0.08);
    }
</style>
